var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  className: "_dm-svg",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.143 3.429c.473 0 .857.384.857.857v10.857a.857.857 0 01-.857.857H6.572a.857.857 0 01-.857-.857v-2.571H.858a.857.857 0 01-.857-.857v-6c0-.473.277-1.134.607-1.464L4.251.608c.33-.33.991-.607 1.464-.607h3.714c.473 0 .857.384.857.857v2.929c.348-.205.795-.357 1.143-.357h3.714zM10.286 5.33L7.616 8h2.67V5.33zM4.571 1.902l-2.67 2.67h2.67v-2.67zm1.75 5.777l2.821-2.821V1.144H5.713v3.714a.857.857 0 01-.857.857H1.142v5.714h4.571V9.143c0-.473.277-1.134.607-1.464zm8.536 7.178V4.571h-3.429v3.714a.857.857 0 01-.857.857H6.857v5.714h8z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Copy.0d10a8c466b6ff03df08d42673ca1d44.svg";